import {
  MODULES,
  REFERRAL_TYPE,
  TABLE_FILTER_KEYS,
  TRANSACTION_HISTORY_TYPES,
} from '../../../../../common/constants';
import Portal from '../../../../../components/Portal';
import ResetFilterButton from '../../../../../components/ResetFilterButton';
import ReferralTable from '../../endUser/components/ReferralTable';
import LibraryTabs from '../components/LibraryTabs';

const transactionTypes = [
  TRANSACTION_HISTORY_TYPES?.REFERRAL?.value,
  TRANSACTION_HISTORY_TYPES?.ENCASHMENT?.value,
];

const Referral = () => (
  <>
    <Portal portalId="header-title-content">
      <div className="portal-header">{MODULES?.LIBRARY}</div>
    </Portal>
    <ResetFilterButton tableKey={TABLE_FILTER_KEYS.PAYMENTS_LIBRARY_REFERRAL} />{' '}
    <LibraryTabs>
      <div className="tab-table">
        <ReferralTable
          transactionTypes={transactionTypes}
          referredByType={REFERRAL_TYPE?.LIBRARY}
        />
      </div>
    </LibraryTabs>
  </>
);

export default Referral;
